<template>
    <div>
        <BookingBack :isDark="true" title="Review"/>
        <van-form @submit="onSubmit" class="myForm">
            <div class="formItem rateGroup">
                <div class="rateLabel">Rating</div>
                <van-rate v-model="form.score" color="#1A3232" />
            </div>
            <div class="formItem">
                <van-field
                    class="myTextarea"
                    v-model="form.content"
                    name="content"
                    rows="5"
                    autosize
                    required
                    type="textarea"
                    maxlength="200"
                    placeholder="Please enter review content"
                    :rules="[{ required: true }]"
                    show-word-limit
                />
            </div>
            <van-field name="uploader" >
                <template #input>
                    <van-uploader :after-read="afterRead"  v-model="fileList" multiple :max-count="3" :max-size="5000 * 1024" @oversize="onOversize"/>
                </template>
            </van-field>
            <div class="submitBox">
                <van-button block type="info" color="#1E3C3E" native-type="submit">Submit Review</van-button>
            </div>
        </van-form>
    </div>
</template>
<script>
import BookingBack from '@/components/Booking/back.vue'
import { Toast,Notify } from 'vant'
import myMixin from '@/utils/myMixin'
export default {
    name:'RefundOrder',
    props:{
        order_service_id:{
            type:Array,
            default:()=>{
                return []
            }
        }
    },
    data(){
        return {
            fileList:[],
            submitData:{
                order_id:Number(this.$route.query.order_id),
                formData:JSON.parse(this.$route.query.data),
            },
            form:{
                score:0,
                content:'',
                image_list:[]
            },
        }
    },
    mixins:[myMixin],
    components:{
        BookingBack
    },
    mounted(){
    },
    methods:{
        onSubmit(){
            if(  this.form.score > 0 ){
                if( this.fileList.length > 0 ){
                    for(let i in this.fileList ){
                        this.form.image_list.push({file_id:this.fileList[i].file_id,file_path:this.fileList[i].file_path})
                    }
                }
                let data = this.submitData.formData
                for( let i in data ){
                    data[i].score = this.form.score
                    data[i].content = this.form.content
                    data[i].image_list = this.form.image_list
                }
                this.submitData.formData = JSON.stringify(data)
                this.$api.getCommentOrder(this.submitData).then(res=>{
                    if(res.code == 1){
                        Toast('Review submitted')
                        // 跳转到订单页面的Reviewed列表
                        this.$router.push({path: '/order', query: {tab: 'evaluate'}})
                    }else{
                        Toast(res.msg)
                    }
                })
            }else{
                Notify({ type: 'danger', message: 'Please select a rating!' })
            }
        },
        onOversize(file) {
            Toast('File size cannot exceed 5000 KB')
        },
        afterRead(file){
            file.status = 'uploading'
            file.message = 'Uploading...'
            const fd = new FormData()
            fd.append('iFile', file.file,file.file.name)
            this.$api.uploadFile(fd).then(res=>{
                if(res.code == 1){
                    // 上传完毕
                    file.status = 'done'
                    file.message = ''
                    // 设置图片地址
                    file.file_id = res.data.file_id
                    file.url = this.getUrl(res.data.file_path)
                    file.file_path = this.getUrl(res.data.file_path)
                }else{
                    file.status = 'fail'
                    file.message = ''
                    // [{"order_service_id":1,"service_id":1,"score":4,"image_list":[{"file_id":"1","file_path":"http://localhost:8080/uploads/20250828/d2e07d8dfd01e620c4cdcf397f4d00dd.jpg"},{"file_id":"16","file_path":"http://localhost:8080/uploads/20250828/6ac2ed41241cc2ee3fb5406c7711208e.jpg"}],"content":"heheheh"},{"order_service_id":2,"service_id":7,"score":5,"image_list":[{"file_id":"1","file_path":"http://localhost:8080/uploads/20250828/d2e07d8dfd01e620c4cdcf397f4d00dd.jpg"},{"file_id":"16","file_path":"http://localhost:8080/uploads/20250828/6ac2ed41241cc2ee3fb5406c7711208e.jpg"}],"content":"hahahah"}]
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
    .myForm{
        width: 100%;
        .rateGroup{
            margin: 1rem 0;
            .rateLabel{
                font-size: .875rem;
                color: #666666;
                margin-bottom: 0.5rem;
            }
        }
        .formItem{
            width: 100%;
            padding: 0 1rem;
            box-sizing: border-box;
        }
        box-sizing: border-box;
        .myTextarea{
            background-color: #F8F8F8;
            border-radius: .5rem;
        }
    }
    .submitBox{
        width: 100%;
        position: fixed;
        bottom: 1rem;
        left: 50%;
        transform: translate(-50%);
        padding:0 1rem;
        box-sizing: border-box;
        .submitBtn{
            width: 100%;
            height: 2.75rem;
            background: #1E3C3E;
            border-radius: .25rem;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
        }
    }
</style>
